export default __webpack_public_path__ + "static/media/part.37674ddf.png";